export function toSerializableError(error) {
  if(error && error.response && error.response.data) {
    return error.response.data;
  }
  if(error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack
    };
  }
  return error || { message: 'Unknown error' };
}
